export class Dispensing {
  public static isAnimationFast = false
}
